import { Routes, Route, Outlet } from "react-router-dom";
import UserContextProvider from "../context/UserContextProvider";
import { CssBaseline } from "@mui/material";
import UsersList from "../pages/UsersList";
import NewUser from "../pages/NewUser";
import EmptyStateNotFound from "../../clients/components/EmptyState";
import UserDetails from "../pages/UserDetails";

export default function UsersRoutes() {
  return (
    <>
      <UserContextProvider>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<UsersList />} />
          <Route path="/:id" element={<UserDetails />} />
          <Route path="/cadastrar" element={<NewUser />} />
          <Route path="/*" element={<EmptyStateNotFound />} />
        </Routes>
        <Outlet />
      </UserContextProvider>
    </>
  );
}
